import * as React from 'react';

interface IActionTileProps {
	label: string;
	loadingLabel?: string;
	disabled?: boolean;
	onClick?: () => Promise<string>;
}

export const ActionTile: React.FC<IActionTileProps> = (props) => {
	const [state, setState] = React.useState('default');
	const [label, setLabel] = React.useState(props.label);

	const setStatusTimeout = (newState: string, newLabel: string) => {
		console.log(`setting status ${newState}, ${newLabel}`);
		setState(newState);
		setLabel(newLabel);
		setTimeout(() => {
			console.log(`2000ms: setting status default, ${props.label}`);
			setState('default');
			setLabel(props.label);
		}, 2000);
	};

	const handleClick = () => {
		if (props.onClick && !props.disabled) {
			console.log('clickery.');
			setState('loading');
			setLabel(props.loadingLabel || 'Loading');

			props.onClick()
				.then((message) => setStatusTimeout('success', message))
				.catch((e: Error) => setStatusTimeout('error', e.message));
		}
	};

	const classes = [
		'action-tile',
		`action-tile__${state}`,
		...(props.disabled ? ['action-tile__disabled'] : [])
	];

	return <div className={classes.join(' ')} onClick={handleClick}>
		<div className={`action-tile_label action-tile_label__${state}`}>
			{label}
		</div>
		<div className={`action-tile_icon action-tile_icon__${state}`} />
	</div>;
};
